import { useState, useMemo, useEffect, useRef } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import PageWrapper from "../components/PageWrapper";
import { createPortal } from "react-dom";

export default function CancelOrder() {
  const [loading, setLoading] = useState(true);
  const [postingLoading, setPostingLoading] = useState(false);
  const [data, setData] = useState([]);
  const [search, setSearch] = useState("");
  const [activeTab, setActiveTab] = useState("ALL");
  const [reqItem, setReqItem] = useState(null);
  const [openMenu, setOpenMenu] = useState(null);
const [menuPosition, setMenuPosition] = useState({ x: 0, y: 0 });
const [previewImage, setPreviewImage] = useState(null);
const [zoom, setZoom] = useState(1);

const [reqProdukModal, setReqProdukModal] = useState(false);
const [reqProdukData, setReqProdukData] = useState([]);
const [loadingReqProduk, setLoadingReqProduk] = useState(false);
const [reqSku, setReqSku] = useState("");

const [cctvModal, setCctvModal] = useState(false);
const [cctvUrl, setCctvUrl] = useState("");
const [isCctvConnected, setIsCctvConnected] = useState(false);

const [skuModal, setSkuModal] = useState(false);
const [skuItem, setSkuItem] = useState(null);
const [skuInput, setSkuInput] = useState("");

const [uniqModal, setUniqModal] = useState(false);
const [scanItem, setScanItem] = useState(null);
const [uniqInput, setUniqInput] = useState("");


const [menuRef, setMenuRef] = useState(null);
  const [shippingModal, setShippingModal] = useState(false);
const [selectedRow, setSelectedRow] = useState(null);
const [toast, setToast] = useState(null);

const [detailModal, setDetailModal] = useState(false);
const [orderDetail, setOrderDetail] = useState([]);
const [loadingDetail, setLoadingDetail] = useState(false);

const showToast = (message, type = "success") => {
  setToast({ message, type });

  setTimeout(() => {
    setToast(null);
  }, 3000);
};

const [form, setForm] = useState({
  product_condition: "SESUAI",
});

const isValidSku = (sku) => {
  return /^[A-Za-z0-9]{11}$/.test(sku);
};


 const fetchData = async () => {
      try {
        const kode_toko = localStorage.getItem("kode_toko");

         const id_sunfish = localStorage.getItem("id_sunfish");

        const res = await axios.get("/api/tiktokshop/orders-cancel", {
          params: { kode_toko,id_sunfish },
        });

        setData(res.data.data);
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

  // ===== FETCH =====
  useEffect(() => {
   
    fetchData();
  }, []);

  // ===== OUTSIDE CLICK =====
  useEffect(() => {
  const handleClickOutside = (e) => {
  // kalau klik di dalam menu / tombol → jangan close
  if (menuRef?.contains?.(e.target)) return;
  setOpenMenu(null);
};

  document.addEventListener("mousedown", handleClickOutside);
  return () => document.removeEventListener("mousedown", handleClickOutside);
}, []);

const handleRequestProduk = async (storeItem) => {
  try {
    const kode_toko = localStorage.getItem("kode_toko");
    const id_sunfish = localStorage.getItem("id_sunfish");

    await axios.post("/api/tiktokshop/request-product", {
      seller_sku: storeItem.seller_sku,
      kode_toko_asal: storeItem.kode_toko,
      stok: storeItem.stok_akhir,
      kode_toko,
      id_sunfish,
      line_item_id: reqItem?.line_item_id,
    });

    showToast("Request produk terkirim", "success");

    // 🔥 UPDATE LOCAL ORDER DETAIL (NO FETCH)
    setOrderDetail((prev) =>
      prev.map((x) =>
        x.line_item_id === reqItem?.line_item_id
          ? {
              ...x,
              store_product_req: storeItem.nama_toko, // atau nama toko
            }
          : x
      )
    );

  } catch (err) {
    console.error(err);
    showToast("Gagal request produk", "error");
  }
};

  // ===== FORMAT DATE =====
  const formatDate = (date) => {
  if (!date) return "-";

  return new Date(date).toLocaleString("id-ID", {
    timeZone: "Asia/Jakarta",
    day: "2-digit",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
};


const fetchReqProduk = async (sku) => {
  try {
    setLoadingReqProduk(true);

    const res = await axios.get("/api/tiktokshop/req-produk", {
      params: { seller_sku: sku },
    });

    setReqProdukData(res.data.data || []);
  } catch (err) {
    console.error(err);
    showToast("Gagal load produk", "error");
  } finally {
    setLoadingReqProduk(false);
  }
};

useEffect(() => {
  if (reqProdukModal && reqSku) {
    fetchReqProduk(reqSku);
  }
}, [reqProdukModal, reqSku]);

const getMinDateTime = () => {
  const now = new Date();

  // convert ke WIB (UTC+7)
  const wibOffset = 7 * 60;
  const localOffset = now.getTimezoneOffset();
  const wibTime = new Date(now.getTime() + (wibOffset + localOffset) * 60000);

  return wibTime.toISOString().slice(0, 16);
};

const getMaxDateTime = () => {
  const now = new Date();

  const wibOffset = 7 * 60;
  const localOffset = now.getTimezoneOffset();
  const wibTime = new Date(now.getTime() + (wibOffset + localOffset) * 60000);

  wibTime.setDate(wibTime.getDate() + 2); // 🔥 hanya 2 hari ke depan

  return wibTime.toISOString().slice(0, 16);
};


const getSLAStatus = (row) => {
  if (!row?.shipping_due_time) return "SAFE";

  const status = (row.status || "").toUpperCase();

  const SLA_STATUSES = [
    "AWAITING_COLLECTION",
    "AWAITING_SHIPMENT",
  ];

  if (!SLA_STATUSES.includes(status)) return "SAFE";

  const now = Date.now();
  const due = new Date(row.shipping_due_time).getTime();

  if (isNaN(due)) return "SAFE"; // 🔥 guard kalau date rusak

  const diffMs = due - now;
  const diffHours = diffMs / (1000 * 60 * 60);

  if (diffMs < 0) return "OVERDUE";
  if (diffHours < 6) return "WARNING";

  return "SAFE";
};

  // ===== STATUS TABS =====
  const statusTabs = useMemo(() => {
    const map = {};

    data.forEach((d) => {
      const s = d.status || "UNKNOWN";
      map[s] = (map[s] || 0) + 1;
    });

    return [
      { label: "All", value: "ALL", count: data.length },
      ...Object.keys(map).map((key) => ({
        label: key.replaceAll("_", " "),
        value: key,
        count: map[key],
      })),
    ];
  }, [data]);

  // ===== FILTER =====
  const filteredData = data.filter((item) => {
    const keyword = search.toLowerCase();

    const matchSearch =
      item.order_id?.toLowerCase().includes(keyword) ||
      item.cancel_id?.toLowerCase().includes(keyword) ||
      item.back_to?.toLowerCase().includes(keyword);

    const matchTab =
      activeTab === "ALL" || item.status === activeTab;

    return matchSearch && matchTab;
  });

  // ===== STATUS BADGE =====
  const getStatusColor = (status) => {
    const s = status?.toUpperCase();

    if (s === "SUDAH PROSES" || s === "COMPLETED")
      return "bg-green-100 text-green-700";
    if (s === "DELIVERED")
      return "bg-emerald-100 text-emerald-700";
    if (s === "IN_TRANSIT")
      return "bg-blue-100 text-blue-700";
    if (s === "AWAITING_SHIPMENT")
      return "bg-yellow-100 text-yellow-700";
    if (s === "AWAITING_COLLECTION")
      return "bg-purple-100 text-purple-700";
    if (s === "BELUM PROSES" || s === "CANCEL")
      return "bg-red-100 text-red-700";

    return "bg-gray-100 text-gray-600";
  };

  

  const isDisabled =
  orderDetail.some(
    (x) =>
      (x.scan_status || "")
        .trim()
        .toUpperCase() !== "SCANNED_OK"
  ) ||

  (
    form.shipping_type === "SELF" &&
    (
      !form.shipping_provider_id ||
      !form.tracking_number
    )
  );


  // ===== ACTION =====
const handleAction = (type, row) => {
 if (type === "detail") {
  setDetailModal(true);
  setLoadingDetail(true);
  
        const kode_toko = localStorage.getItem("kode_toko");

         const id_sunfish = localStorage.getItem("id_sunfish");

  axios
    .get("/api/tiktokshop/order-details-cancel", {
      params: { order_id: row.order_id,cancel_id: row.cancel_id,kode_toko },
    })
    .then((res) => {
      setOrderDetail(res.data.data);
    })
    .finally(() => setLoadingDetail(false));
}

  if (type === "invoice") {
    window.open(`/invoice/${row.order_id}`, "_blank");
  }

  if (type === "shipping") {
    if (!row.doc_url) {
      alert("Shipping label belum tersedia");
      return;
    }

    window.open(row.doc_url, "_blank", "noopener,noreferrer");
  }

 if (type === "arrange_shipping") {
  setSelectedRow(row);
  setShippingModal(true);

  setForm({
    handover_method: "PICKUP",
    pickup_slot_start: "",
    pickup_slot_end: "",
  });
}

  setOpenMenu(null);
};


  // ===== COLUMNS =====
  const columns = [
    {
      name: "Order",
      minWidth: "220px",
      cell: (row) => (
        <div className="py-3">
          <div className="font-semibold text-gray-900">
            {row.order_id}
          </div>
        </div>
      ),
    },
    {
      name: "Tanggal",
      cell: (row) => (
        <div className="text-sm text-gray-500">
          {row.create_time}
        </div>
      ),
    },
    {
      name: "Type Pembatalan",
      cell: (row) => (
        <div className="py-2">
          <div className="font-medium text-gray-900">
            {row.cancel_type}
          </div>
          <div className="text-xs text-gray-500">
            {row.cancel_reason_text}
          </div>
        </div>
      ),
    },
    {
      name: "Status",
      cell: (row) => (
        <span
          className={`px-3 py-1 text-xs rounded-full font-medium ${getStatusColor(
            row.status
          )}`}
        >
          {row.status}
        </span>
      ),
    },
  
    {
      name: "Kategori",
      selector: (row) => row.biensi_type || "-",
    },
     {
      name: "Order From",
      selector: (row) => row.order_from || "-",
    },
    {
      name: "Dikembalikan ke",
      selector: (row) => row.back_to || "-",
    },
    
    {
      name: "",
      width: "60px",
      cell: (row) => (
        <div  ref={menuRef}>
         <button
  onClick={(e) => {
    
    const rect = e.currentTarget.getBoundingClientRect();

    const dropdownWidth = 160;
    const dropdownHeight = 120;

    let x = rect.right;
    let y = rect.bottom;

    if (x > window.innerWidth) {
      x = window.innerWidth - dropdownWidth - 10;
    }

    if (y + dropdownHeight > window.innerHeight) {
      y = rect.top - dropdownHeight;
    }

    setMenuPosition({ x, y });
    setOpenMenu(openMenu === row.cancel_id ? null : row.cancel_id);
  }}
  className="p-2 rounded-lg hover:bg-gray-100 transition"
>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className="w-5 h-5 text-gray-600"
    fill="currentColor"
    viewBox="0 0 24 24"
  >
    <circle cx="12" cy="5" r="2" />
    <circle cx="12" cy="12" r="2" />
    <circle cx="12" cy="19" r="2" />
  </svg>
</button>

       {openMenu === row.cancel_id &&
  createPortal(
    <div
      className="fixed w-40 bg-white border rounded-lg shadow-lg z-[99999]"
      style={{
        top: menuPosition.y,
        left: menuPosition.x - 160,
      }}
      onMouseDown={(e) => e.stopPropagation()}
    >
    <button
        onClick={() => handleAction("detail", row)}
        className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50"
      >
        Detail
      </button>
    

    </div>,
    document.body
  )
}
        </div>
      ),
    },
  ];

const customStyles = {
  tableWrapper: {
    style: {
      overflow: "visible",
    },
  },
 table: {
  style: {
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    overflow: "hidden",
  },
},
  headRow: {
    style: {
      overflow: "visible",
    },
  },
rows: {
  style: (row) => {
    const sla = getSLAStatus(row);

    return {
      backgroundColor:
        sla === "OVERDUE"
          ? "#fee2e2"
          : sla === "WARNING"
          ? "#ffedd5"
          : "transparent",
      borderLeft:
        sla === "OVERDUE"
          ? "4px solid #dc2626"
          : sla === "WARNING"
          ? "4px solid #f97316"
          : "none",
          borderBottom: "1px solid #e5e7eb",
    };
  },
},
  cells: {
    style: {
      overflow: "visible",
    },
  },
  headCells: {
    style: {
      fontSize: "12px",
      fontWeight: "600",
      backgroundColor: "#f9fafb",
    },
  },
};

  return (
    <PageWrapper>
      {toast && (
  <div
    className={`fixed top-5 right-5 z-[9999999] px-4 py-3 rounded-lg shadow-lg text-white 
      ${toast.type === "success" ? "bg-green-600" : "bg-red-600"}
    `}
  >
    {toast.message}
  </div>
)}
      <div className="space-y-5">

        {/* HEADER */}
        <div>
          <h1 className="text-xl font-semibold text-gray-800">
            Cancel Product Order Tiktok Shop
          </h1>
          <p className="text-sm text-gray-500">
            Real-time order monitoring & fulfillment
          </p>
        </div>

        {/* TABS */}
        {/* TABS */}
<div className="flex gap-3 flex-wrap bg-gray-50 p-2 rounded-2xl border">

 {statusTabs.map((tab) => {
  const isActive = activeTab === tab.value;
  const isSLA = tab.value === "AWAITING_SHIPMENT";

  return (
    <button
      key={tab.value}
      onClick={() => setActiveTab(tab.value)}
      className={`flex items-center gap-2 px-5 py-3 rounded-xl border transition font-medium

        ${
          isActive
            ? isSLA
              ? "bg-red-600 text-white shadow-md"   // 🔥 aktif + SLA
              : "bg-gray-900 text-white shadow-md"
            : isSLA
              ? "bg-red-50 text-red-600 border-red-200 hover:bg-red-100" // 🔥 non aktif tapi highlight
              : "bg-white text-gray-700 hover:bg-gray-100"
        }
      `}
    >
      <span className="text-sm font-semibold">
        {tab.label}
      </span>

      <span
        className={`text-xs px-2 py-0.5 rounded-full
          ${
            isActive
              ? "bg-white/20 text-white"
              : isSLA
                ? "bg-red-100 text-red-600"
                : "bg-gray-100 text-gray-600"
          }
        `}
      >
        {tab.count}
      </span>

      {/* 🔥 optional: indikator SLA */}
      {isSLA && (
        <span className={`text-xs ${isActive ? "text-white" : "text-red-500"}`}>
          ●
        </span>
      )}
    </button>
  );
})}

</div>

        {/* TABLE */}
        <div className="bg-white border rounded-2xl shadow-sm p-4">

          {/* SEARCH */}
          <div className="flex justify-between mb-3">
            <input
              className="border rounded-xl px-3 py-2 text-sm w-72"
              placeholder="Search order or customer..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />

            <div className="text-xs text-gray-500">
              {filteredData.length} orders
            </div>
          </div>

          {/* TABLE */}
          <DataTable
            columns={columns}
            data={filteredData}
            progressPending={loading}
            pagination
            customStyles={customStyles}
            highlightOnHover
            persistTableHead
            
conditionalRowStyles={[
  {
    when: (row) => getSLAStatus(row) === "OVERDUE",
    style: {
      backgroundColor: "#fee2e2 !important",
      borderLeft: "4px solid #dc2626",
    },
  },
  {
    when: (row) => getSLAStatus(row) === "WARNING",
    style: {
      backgroundColor: "#ffedd5 !important",
      borderLeft: "4px solid #f97316",
    },
  },
]}
          />
        </div>
      </div>
{shippingModal && selectedRow?.package_id && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center z-[999999]">

    <div className="bg-white w-[460px] rounded-2xl p-6 shadow-2xl space-y-5 animate-fadeIn">

      {/* HEADER */}
      <div className="flex items-center justify-between">
        <div>
          <div className="text-lg font-bold">Arrange Shipping</div>
          <div className="text-xs text-gray-500">
            Package ID: {selectedRow.package_id}
          </div>
        </div>

        <button
          onClick={() => setShippingModal(false)}
          className="text-gray-400 hover:text-black text-xl"
        >
          ✕
        </button>
      </div>

      {/* SHIPPING TYPE */}
      
      {/* ================= TIKTOK ================= */}
      {form.shipping_type === "TIKTOK" && (
        <>
          <div>
            <label className="text-sm font-medium">Handover Method</label>
            <select
              className="w-full border rounded-xl px-3 py-2 mt-1"
              value={form.handover_method}
              onChange={(e) =>
                setForm({ ...form, handover_method: e.target.value })
              }
            >
              <option value="PICKUP">Pickup</option>
              <option value="DROP_OFF">Drop Off</option>
            </select>
          </div>

          {form.handover_method === "PICKUP" && (
            <div className="grid grid-cols-2 gap-3">
              <div>
                <label className="text-sm font-medium">Start</label>
                <input
                  type="datetime-local"
                  className="w-full border rounded-xl px-3 py-2 mt-1"
                  value={form.pickup_slot_start}
                  min={getMinDateTime()}
                  max={getMaxDateTime()}
                  step="1800"
                  onChange={(e) =>
                    setForm({ ...form, pickup_slot_start: e.target.value })
                  }
                />
              </div>

              <div>
                <label className="text-sm font-medium">End</label>
                <input
                  type="datetime-local"
                  className="w-full border rounded-xl px-3 py-2 mt-1"
                  value={form.pickup_slot_end}
                  min={form.pickup_slot_start || getMinDateTime()}
                  max={getMaxDateTime()}
                  step="1800"
                  onChange={(e) =>
                    setForm({ ...form, pickup_slot_end: e.target.value })
                  }
                />
              </div>
            </div>
          )}
        </>
      )}

      {/* ================= SELF SHIPPING ================= */}
      {form.shipping_type === "SELF" && (
        <>
          <div>
            <div className="bg-red-50 border border-red-200 text-red-700 text-xs p-3 rounded-xl leading-relaxed">
  <div className="font-semibold mb-1">
    Self Shipment (Kirim Sendiri)
  </div>

  <ul className="list-disc pl-4 space-y-1">
    <li>
      Seller bertanggung jawab atas biaya pengiriman awal (talang ke ekspedisi).
    </li>
    <li>
      Risiko retur / gagal kirim mengikuti kebijakan TikTok Shop.
    </li>
    <li>
      Pastikan resi valid & dapat dilacak sebelum submit.
    </li>
  </ul>

  {/* 🔗 CLICKABLE LINK */}
  <div className="mt-2 text-[11px]">
    Referensi resmi:{" "}
    <a
      href="https://seller-id.tokopedia.com/university/essay?knowledge_id=6837727601690370"
      target="_blank"
      rel="noopener noreferrer"
      className="text-blue-600 underline hover:text-blue-800"
    >
      TikTok Shop Seller University
    </a>
  </div>
</div>
            <label className="text-sm font-medium">Shipping Provider</label>

            {/* PROVIDER GRID */}
            <div className="grid grid-cols-2 gap-3 mt-2">

              {[
                { id: "6664359930134757378", name: "SiCepat", logo: "https://play-lh.googleusercontent.com/Nvroryrc2dSDGq6dReWzSjzixjYvEvmkvIAvYtQpzSPS3nktqY8MJYxSmMI6hvwBMw" },
                { id: "6841743441349706241", name: "J&T", logo: "data:image/png;base64,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" },
                { id: "6986111201075791621", name: "SAP", logo: "https://www.sapx.id/assets/frontend-3.0/img/favicon/sapx-express-favicon.svg" },
                { id: "7075220915323143937", name: "Ninja Van", logo: "https://www.ninjaxpress.co//favicon/favicon.ico" },
                { id: "7210588319724390149", name: "JNE", logo: "https://jne.co.id/cfind/source/images/logo.svg" },
              ].map((p) => (
                <button
                  key={p.id}
                  onClick={() =>
                    setForm({ ...form, shipping_provider_id: p.id })
                  }
                  className={`flex items-center gap-2 border rounded-xl p-2 hover:shadow-md transition ${
                    form.shipping_provider_id === p.id
                      ? "border-black bg-gray-50"
                      : "border-gray-200"
                  }`}
                >
                  <img src={p.logo} className="w-8 h-8 object-contain" />
                  <span className="text-sm font-medium">{p.name}</span>
                </button>
              ))}

            </div>
          </div>

          <div>
            <label className="text-sm font-medium">Tracking Number</label>
            <input
              type="text"
              className="w-full border rounded-xl px-3 py-2 mt-1"
              placeholder="Masukkan resi"
              value={form.tracking_number}
              onChange={(e) =>
                setForm({ ...form, tracking_number: e.target.value })
              }
            />
          </div>
        </>
      )}

      {/* ACTION BUTTONS */}
      <div className="flex justify-end gap-2 pt-2">
        <button
          onClick={() => setShippingModal(false)}
          className="px-4 py-2 text-sm border rounded-xl hover:bg-gray-100"
        >
          Cancel
        </button>

        <button
          disabled={isDisabled}
          onClick={async () => {
            try {
              let payload = { package_id: selectedRow.package_id };

              if (form.shipping_type === "TIKTOK") {
                payload.handover_method = form.handover_method;
                payload.pickup_slot_start = form.pickup_slot_start;
                payload.pickup_slot_end = form.pickup_slot_end;
              }

              if (form.shipping_type === "SELF") {
                payload.shipping_type = "SELF";
                payload.shipping_provider_id = form.shipping_provider_id;
                payload.tracking_number = form.tracking_number;
              }

              await axios.post("/api/tiktokshop/ship-package", payload);

              showToast("Shipping berhasil dibuat 🚚", "success");

              setShippingModal(false);
              setSelectedRow(null);
              fetchData();

            } catch (err) {
              console.error(err);
              showToast("Gagal assign shipping", "error");
            }
          }}
          className="px-5 py-2 text-sm bg-black text-white rounded-xl disabled:bg-gray-400"
        >
          Submit
        </button>
      </div>

    </div>
  </div>
)}

{detailModal && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999] p-4">

    <div className="bg-white w-[1400px] max-w-[98vw] h-[92vh] rounded-2xl shadow-2xl overflow-hidden flex">

      {/* ================================= */}
      {/* LEFT PANEL */}
      {/* ================================= */}
      <div className="w-[430px] border-r bg-white flex flex-col">

        {/* HEADER */}
        <div className="p-6 border-b">

          <div className="flex items-start justify-between gap-4">

            <div>

              <div className="font-bold text-2xl text-gray-800">
                Product Cancel Order
              </div>

              <div className="text-sm text-gray-500 mt-1">
                Order ID: {orderDetail?.[0]?.order_id || "-"}
              </div>

            </div>

          <button
  onClick={() => setCctvModal(true)}
  className={`px-3 py-1 text-xs rounded-lg border transition font-semibold

    ${
      isCctvConnected
        ? "bg-emerald-100 text-emerald-700 border-emerald-300"
        : "bg-red-100 text-red-700 border-red-400 animate-pulse shadow-md"
    }
  `}
>
  {isCctvConnected ? "CCTV ON" : "CCTV OFF"}
</button>

            <button
              onClick={() => setDetailModal(false)}
              className="text-gray-400 hover:text-black text-2xl"
            >
              ✕
            </button>

          </div>

          {/* CUSTOMER */}
          <div className="mt-4">

            <div className="bg-gray-50 border rounded-xl px-4 py-3">

              <div className="text-[11px] uppercase tracking-wide text-gray-500">
                Customer
              </div>

              <div className="text-sm font-semibold text-gray-800 mt-1">
                {orderDetail?.[0]?.recipient_name || "-"}
              </div>

              <div className="text-[11px] uppercase tracking-wide text-gray-500">
                Store Order
              </div>

              <div className="text-sm font-semibold text-gray-800 mt-1">
                {orderDetail?.[0]?.store_product_req_order || "-"}
              </div>

            </div>

          </div>

        </div>

        {/* BODY */}
        <div className="flex-1 overflow-y-auto p-6 space-y-5">

          {/* SUMMARY */}
          <div className="grid grid-cols-3 gap-3">

            <div className="border rounded-xl p-4 bg-white">

              <div className="text-xs text-gray-500">
                Total Item
              </div>

              <div className="text-2xl font-bold text-gray-800 mt-1">
                {orderDetail.length}
              </div>

            </div>

            <div className="border rounded-xl p-4 bg-emerald-50 border-emerald-200">

              <div className="text-xs text-emerald-600">
                Scanned
              </div>

              <div className="text-2xl font-bold text-emerald-700 mt-1">
                {
                  orderDetail.filter(
                    (x) => x.scan_status === "SCANNED_OK"
                  ).length
                }
              </div>

            </div>

            <div className="border rounded-xl p-4 bg-yellow-50 border-yellow-200">

              <div className="text-xs text-yellow-600">
                Pending
              </div>

              <div className="text-2xl font-bold text-yellow-700 mt-1">
                {
                  orderDetail.filter(
                    (x) => x.scan_status === "PENDING"
                  ).length
                }
              </div>

            </div>

          </div>

          {/* GLOBAL SCAN */}
          <div>

            <div className="text-sm font-medium text-gray-700 mb-2">
              Scan Barcode SKU
            </div>

            <input
              type="text"
              placeholder="Scan Barcode/QR Uniq ID.."
              autoFocus
              className="w-full border-2 border-gray-200 focus:border-emerald-500 rounded-xl px-4 py-4 outline-none text-lg"
              onKeyDown={async (e) => {

                if (e.key !== "Enter") return;

                const scannedValue = e.target.value.trim();
                const normalizedScan = scannedValue.toUpperCase();

                if (!scannedValue) return;

                try {

                  const kode_toko = localStorage.getItem("kode_toko");

         const id_sunfish = localStorage.getItem("id_sunfish");

                    const targetItem = orderDetail.find(
        (x) =>
          x.seller_sku?.toUpperCase() === normalizedScan &&
          x.scan_status !== "SCANNED_OK"
      );

                  if (!targetItem) {

                    showToast(
                      "SKU tidak ditemukan di order",
                      "error"
                    );

                    e.target.value = "";

                    return;
                  }

                  await axios.post(
                    "/api/tiktokshop/scan-cancel-item",
                    {
                      order_id: targetItem.order_id,
                      line_item_id: targetItem.line_item_id,
                      scanned_sku: normalizedScan,
                      kode_toko_asal:targetItem.kode_toko_asal,
                       kode_toko_tujuan:targetItem.kode_toko_tujuan,
                       kode_extend:targetItem.kode_extend,
                       package_id:targetItem.package_id,
                       id_sunfish: id_sunfish,
                    }
                  );

                  setOrderDetail((prev) =>
                    prev.map((x) =>
                      x.line_item_id === targetItem.line_item_id
                        ? {
                            ...x,
                            scanned_sku: normalizedScan,
                            is_match: true,
                            scan_status: "SCANNED_OK",
                          }
                        : x
                    )
                  );

                  showToast(
                    `${normalizedScan} scanned`,
                    "success"
                  );

                  e.target.value = "";

                } catch (err) {

                  console.error(err);

                  showToast(
                    "Gagal scan item",
                    "error"
                  );
                }

              }}
            />

          </div>

          {/* SHIPPING PROVIDER */}
          <div className="bg-emerald-50 border border-emerald-200 rounded-xl p-4">

            <div className="text-xs text-emerald-600 uppercase tracking-wide">
              Shipping Provider
            </div>

            <div className="text-lg font-bold text-emerald-800 mt-1">
              {orderDetail?.[0]?.shipping_provider_name || "-"}
            </div>

          </div>

          {/* SHIPPING FORM */}
          <div className="border rounded-2xl p-4 space-y-4 bg-gray-50">

            <div className="font-semibold text-gray-800">
              Kondisi Produk
            </div>

            {/* SHIPPING TYPE */}
            <div>
              <label className="text-sm font-medium">
                Kondisi
              </label>

              <select
                className="w-full border rounded-xl px-3 py-2 mt-1"
                value={form.product_condition}
                onChange={(e) =>
                  setForm({
                    ...form,
                    product_condition: e.target.value,
                  })
                }
              >
                <option value="SESUAI">
                  SESUAI
                </option>

                <option value="TIDAK_SESUAI">
                  TIDAK SESUAI
                </option>
              </select>
            </div>

            {/* TIKTOK */}
           
            {/* SELF */}
         
          </div>

        </div>

        {/* FOOTER */}
        <div className="p-6 border-t">

          <div className="flex gap-3">

            <button
  disabled={
    postingLoading ||
    isDisabled ||
    orderDetail.some(
      (x) => x.scan_status !== "SCANNED_OK"
    )
  }
             onClick={async () => {

  try {

    setPostingLoading(true);

    const payload = {
      package_id: orderDetail?.[0]?.package_id,

      // kondisi produk
      product_condition: form.product_condition,

      // semua item detail
      items: orderDetail.map((x) => ({
        line_item_id: x.line_item_id,
        seller_sku: x.seller_sku,
        scan_status: x.scan_status,
      })),
    };

    // 1. update posting
    await axios.post(
      "/api/tiktokshop/posting-cancel-product",
      payload
    );

    // 2. update local UI
    setOrderDetail((prev) =>
      prev.map((x) => ({
        ...x,
        posting_status: "POSTED",
      }))
    );

    // 3. refresh master table
    await fetchData();

    showToast(
      "Posting berhasil 🚚",
      "success"
    );

    setDetailModal(false);

  } catch (err) {

    console.error(err);

    showToast(
      err?.response?.data?.message ||
      "Gagal posting",
      "error"
    );

  } finally {

    setPostingLoading(false);

  }

}}
              className="flex-1 bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-5 py-3 rounded-xl transition disabled:bg-gray-400"
            >
              {postingLoading ? "PROCESSING..." : "POSTING"}
            </button>

            <button
              onClick={() => setDetailModal(false)}
              className="flex-1 border border-gray-300 hover:bg-gray-100 text-gray-700 font-medium px-5 py-3 rounded-xl transition"
            >
              Tutup
            </button>

          </div>

        </div>

      </div>

      {/* ================================= */}
      {/* RIGHT PANEL */}
      {/* ================================= */}
      <div className="flex-1 flex flex-col bg-gray-50">

        {/* HEADER */}
        <div className="px-6 py-5 border-b bg-white">

          <div className="text-xl font-bold text-gray-800">
            Daftar Item Order
          </div>

          <div className="text-sm text-gray-500 mt-1">
            Monitoring item untuk proses packing
          </div>

        </div>

        {/* TABLE HEADER */}
        <div className="grid grid-cols-6 bg-gray-100 px-6 py-3 border-b text-xs font-semibold text-gray-500 uppercase tracking-wide">

          <div>Pict</div>
          <div>Product</div>
          <div>SKU</div>
          <div>Harga</div>
          <div>Status</div>
          <div className="text-center">Action</div>

        </div>

        {/* BODY */}
        <div className="flex-1 overflow-y-auto relative">

          {loadingDetail ? (

            <div className="h-full flex items-center justify-center text-sm text-gray-400">
              Loading...
            </div>

          ) : orderDetail.length === 0 ? (

            <div className="h-full flex items-center justify-center text-sm text-gray-400">
              Tidak ada item
            </div>

          ) : (

            orderDetail.map((item) => (

              <div
                key={item.line_item_id}
                className={`
                grid grid-cols-6 items-center px-6 py-4 border-b transition

                ${
                  item.scan_status === "SCANNED_OK"
                    ? "bg-emerald-50"
                    : item.scan_status === "MISMATCH"
                    ? "bg-red-50"
                    : "bg-white hover:bg-gray-50"
                }
              `}
              >

                {/* IMAGE */}
                <div className="flex justify-start">

                  <img
                    src={item.sku_image}
                    className="w-12 h-12 rounded-lg cursor-pointer object-cover border"
                     onClick={() => {
        setPreviewImage(item.sku_image);
        setZoom(1);
      }}
                    onError={(e) => {
                      e.target.src = "/no-image.png";
                    }}
                  />

                </div>

                {/* PRODUCT */}
              <div>
  {/* PRODUCT NAME (dibatasi + ellipsis) */}
 <div
  className="font-semibold text-sm text-gray-800 line-clamp-2"
  title={item.product_name}
>
  {item.product_name}
</div>

  {/* QTY */}
  <div className="text-xs text-gray-500 mt-1">
    Qty: {item.quantity || 1}
  </div>

  {/* NOTE REQUEST STATUS */}
  {item.store_product_req && (
    <div className="text-[11px] italic text-blue-500 mt-1 leading-snug">
      <span className="font-medium">
        {item.store_product_req}
      </span>
    </div>
  )}
</div>

                {/* SKU */}
                <div>

                  <div className="text-sm font-medium text-gray-700">
                    {item.seller_sku || "-"}
                  </div>

                  {item.scanned_sku && (
                    <div className="text-[11px] text-gray-500 mt-1">
                      Scan: {item.scanned_sku}
                    </div>
                  )}

                </div>

                {/* PRICE */}
                <div>

                  <div className="font-semibold text-sm text-gray-800">
                    Rp {item.sale_price}
                  </div>

                </div>

                {/* STATUS */}
                <div>

                  {item.scan_status === "SCANNED_OK" && (
                    <span className="text-xs bg-emerald-100 text-emerald-700 px-3 py-1 rounded-lg font-medium">
                      SCANNED
                    </span>
                  )}

                  {item.scan_status === "MISMATCH" && (
                    <span className="text-xs bg-red-100 text-red-700 px-3 py-1 rounded-lg font-medium">
                      MISMATCH
                    </span>
                  )}

                  {item.scan_status === "PENDING" && (
                    <span className="text-xs bg-yellow-100 text-yellow-700 px-3 py-1 rounded-lg font-medium">
                      PENDING
                    </span>
                  )}

                </div>

                {/* ACTION */}
                <div className="flex justify-center">

                  <div className="flex flex-wrap gap-2 justify-center">

                    <button
                      onClick={() => {
                        setSkuItem(item);
                        setSkuInput(item.seller_sku || "");
                        setSkuModal(true);
                      }}
                      className="text-xs bg-yellow-100 hover:bg-yellow-200 text-yellow-700 px-3 py-1 rounded-lg font-medium transition"
                    >
                      SKU
                    </button>

                 <button
  onClick={() => {
    setReqSku(item.seller_sku);

    // ✅ SIMPAN FULL ITEM (INI PENTING)
    setReqItem(item);

    setReqProdukModal(true);
  }}
  className="text-xs bg-purple-100 hover:bg-purple-200 text-purple-700 px-3 py-1 rounded-lg font-medium transition"
>
  Req Produk
</button>
                  </div>

                </div>

              </div>

            ))

          )}

        </div>

      </div>

    </div>

  </div>
)}

{uniqModal && scanItem && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999]">
    
    <div className="bg-white w-[420px] rounded-2xl p-5 shadow-xl space-y-4">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <div className="font-bold">Scan / Set Unique ID</div>
          <div className="text-xs text-gray-500">
            {scanItem.product_name}
          </div>
        </div>

        <button
          onClick={() => setUniqModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>
      </div>

      {/* QR IMAGE PREVIEW */}
      <div className="flex justify-center">
        <img
          src={`https://api.qrserver.com/v1/create-qr-code/?size=160x160&data=${scanItem.unique_id || scanItem.line_item_id}`}
          className="w-40 h-40 border rounded-xl"
        />
      </div>

      {/* INFO */}
      <div className="text-center text-xs text-gray-500">
        Scan QR tag pada barang atau masukkan manual ID
      </div>

      {/* INPUT MANUAL */}
      <input
        value={uniqInput}
        onChange={(e) => setUniqInput(e.target.value)}
        placeholder="Masukkan / Scan Unique ID"
        className="w-full border rounded-xl px-3 py-2 text-sm"
      />

      {/* ACTION */}
      <div className="flex gap-2 justify-end">
        <button
          onClick={() => setUniqModal(false)}
          className="px-4 py-2 text-sm border rounded-xl"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            axios.post("/api/tiktokshop/set-unique-id", {
              line_item_id: scanItem.line_item_id,
              unique_id: uniqInput,
            })
            .then(() => {
              showToast("Unique ID tersimpan", "success");

              setOrderDetail((prev) =>
                prev.map((d) =>
                  d.line_item_id === scanItem.line_item_id
                    ? { ...d, unique_id: uniqInput }
                    : d
                )
              );

              setUniqModal(false);
            })
            .catch(() => showToast("Gagal simpan ID", "error"));
          }}
          className="px-4 py-2 text-sm bg-purple-600 text-white rounded-xl"
        >
          Simpan
        </button>
      </div>

    </div>
  </div>
)}

{skuModal && skuItem && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999]">

    <div className="bg-white w-[450px] rounded-2xl p-5 space-y-4">

      {/* HEADER */}
      <div className="flex justify-between items-center">
        <div>
          <div className="font-bold">Barcode SKU</div>
          <div className="text-xs text-gray-500">
            {skuItem.product_name}
          </div>
        </div>

        <button
          onClick={() => setSkuModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>
      </div>

      {/* 🧾 BARCODE IMAGE */}
      <div className="flex flex-col items-center gap-2">
        <img
  src={`https://bwipjs-api.metafloor.com/?bcid=code128&text=${encodeURIComponent(
    skuItem.seller_sku || ""
  )}&scale=2&height=10&includetext`}
  alt="barcode"
  className="w-[220px] h-[80px] object-contain bg-white p-2 border rounded-lg"
/>

        <div className="text-xs text-gray-500">
          SKU: <span className="font-medium">{skuItem.seller_sku}</span>
        </div>
      </div>

      {/* INPUT MANUAL */}
      <input
        value={skuInput}
        onChange={(e) => setSkuInput(e.target.value)}
        placeholder="Edit SKU manual"
        className="w-full border rounded-xl px-3 py-2 text-sm"
      />

      {/* ACTION */}
      <div className="flex justify-end gap-2">
        <button
          onClick={() => setSkuModal(false)}
          className="px-4 py-2 text-sm border rounded-xl"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            axios.post("/api/tiktokshop/update-sku", {
              line_item_id: skuItem.line_item_id,
              seller_sku: skuInput,
            })
            .then(() => {
              showToast("SKU berhasil diupdate", "success");

              setOrderDetail((prev) =>
                prev.map((d) =>
                  d.line_item_id === skuItem.line_item_id
                    ? { ...d, seller_sku: skuInput }
                    : d
                )
              );

              setSkuModal(false);
            })
            .catch(() => showToast("Gagal update SKU", "error"));
          }}
          className="px-4 py-2 text-sm bg-yellow-500 text-white rounded-xl"
        >
          Simpan SKU
        </button>
      </div>

    </div>
  </div>
)}

{cctvModal && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999]">
    
    <div className="bg-white w-[500px] rounded-2xl p-5 space-y-4">

      <div className="flex justify-between items-center">
        <div className="font-bold text-lg">Connect CCTV</div>

        <button
          onClick={() => setCctvModal(false)}
          className="text-gray-500 hover:text-black"
        >
          ✕
        </button>
      </div>

      <div className="text-xs text-gray-500">
        Masukkan RTSP / Stream URL CCTV
      </div>

      <input
        value={cctvUrl}
        onChange={(e) => setCctvUrl(e.target.value)}
        placeholder="rtsp://192.168.1.10:554/stream1"
        className="w-full border rounded-xl px-3 py-2 text-sm"
      />

      {/* PREVIEW PLACEHOLDER */}
      <div className="bg-black rounded-xl h-[260px] flex items-center justify-center text-white text-xs">
        {isCctvConnected ? "🔴 LIVE STREAM (placeholder)" : "No CCTV Connected"}
      </div>

      <div className="flex gap-2 justify-end">

        <button
          onClick={() => setCctvModal(false)}
          className="px-4 py-2 text-sm border rounded-xl"
        >
          Cancel
        </button>

        <button
          onClick={() => {
            if (!cctvUrl) return;

            setIsCctvConnected(true);
            setCctvModal(false);

            // nanti bisa connect ke WebRTC / MediaMTX
            showToast("CCTV Connected", "success");
          }}
          className="px-4 py-2 text-sm bg-emerald-600 text-white rounded-xl"
        >
          Connect
        </button>

      </div>

    </div>

  </div>
)}

{reqProdukModal && (
  <div className="fixed inset-0 bg-black/60 backdrop-blur flex items-center justify-center z-[999999]">

    <div className="bg-white w-[950px] max-w-[95vw] rounded-2xl p-5">

      {/* ================= HEADER ================= */}
      <div className="flex justify-between items-start mb-4">

        <div>
          <div className="font-bold text-lg text-gray-800">
            Req Produk (Cross Store Stock)
          </div>

          <div className="text-xs text-gray-500 mt-1">
            SKU: <span className="font-semibold">{reqSku}</span>
          </div>
        </div>

        <button
          onClick={() => setReqProdukModal(false)}
          className="text-gray-500 hover:text-black text-lg"
        >
          ✕
        </button>
      </div>

      {/* ================= TABLE ================= */}
      <div className="border rounded-xl overflow-hidden">

        {/* HEADER */}
        <div className="grid grid-cols-5 bg-gray-100 text-xs font-semibold p-3 text-gray-600 uppercase">
          <div>SKU</div>
          <div>Toko</div>
          <div>Stok</div>
          <div>Status</div>
          <div className="text-center">Action</div>
        </div>

        {/* BODY */}
        <div className="max-h-[420px] overflow-y-auto">

          {loadingReqProduk ? (
            <div className="p-6 text-center text-gray-400">
              Loading data...
            </div>

          ) : reqProdukData.length === 0 ? (
            <div className="p-6 text-center text-gray-400">
              Data tidak ditemukan
            </div>

          ) : (
            reqProdukData.map((item, i) => (
              <div
                key={i}
                className="grid grid-cols-5 p-3 border-b text-sm items-center hover:bg-gray-50"
              >

                {/* SKU */}
                <div className="text-gray-700 font-medium">
                  {item.seller_sku}
                </div>

                {/* TOKO */}
              {/* TOKO */}
<div className="text-gray-700 whitespace-nowrap overflow-hidden text-ellipsis">
  {item.nama_toko}
</div>

                {/* STOCK */}
                <div>
                  <span className={`px-2 py-1 rounded text-xs font-semibold
                    ${
                      item.stok_akhir > 10
                        ? "bg-emerald-100 text-emerald-700"
                        : item.stok_akhir > 0
                        ? "bg-yellow-100 text-yellow-700"
                        : "bg-red-100 text-red-700"
                    }
                  `}>
                    {item.stok_akhir}
                  </span>
                </div>

                {/* STATUS */}
                <div className="text-xs text-gray-500">
                  {item.stok_akhir > 0 ? "AVAILABLE" : "EMPTY"}
                </div>

                {/* ACTION */}
                <div className="flex justify-center">

                  <button
                    onClick={() => handleRequestProduk(item)}
                    disabled={item.stok_akhir <= 0}
                    className={`text-xs px-3 py-1 rounded-lg font-medium transition
                      ${
                        item.stok_akhir > 0
                          ? "bg-blue-100 hover:bg-blue-200 text-blue-700"
                          : "bg-gray-100 text-gray-400 cursor-not-allowed"
                      }
                    `}
                  >
                    Request
                  </button>

                </div>

              </div>
            ))
          )}

        </div>
      </div>

      {/* ================= FOOTER ================= */}
      <div className="flex justify-end mt-4">
        <button
          onClick={() => setReqProdukModal(false)}
          className="px-4 py-2 border rounded-lg text-sm hover:bg-gray-100"
        >
          Tutup
        </button>
      </div>

    </div>
  </div>
)}

{previewImage && (
  <div className="fixed inset-0 bg-black/80 flex items-center justify-center z-[999999]">

    {/* CLOSE */}
    <button
      onClick={() => setPreviewImage(null)}
      className="absolute top-5 right-5 text-white text-2xl"
    >
      ✕
    </button>

    {/* ZOOM CONTROLS */}
    <div className="absolute bottom-6 flex gap-3">

      <button
        onClick={() => setZoom((z) => Math.max(0.5, z - 0.2))}
        className="bg-white px-3 py-1 rounded"
      >
        -
      </button>

      <button
        onClick={() => setZoom(1)}
        className="bg-white px-3 py-1 rounded"
      >
        Reset
      </button>

      <button
        onClick={() => setZoom((z) => Math.min(3, z + 0.2))}
        className="bg-white px-3 py-1 rounded"
      >
        +
      </button>

    </div>

    {/* IMAGE */}
    <img
      src={previewImage}
      style={{
        transform: `scale(${zoom})`,
        transition: "0.2s",
        maxHeight: "85vh",
        maxWidth: "85vw",
      }}
      className="rounded-lg"
    />

  </div>
)}
    </PageWrapper>
  );
}